import React, { Component } from 'react';

import ToggleButton from 'react-toggle-button'
import styles from './Toggle.scss'

const trStyle = { height: 25, width: 48 }
const thStyle = { height: 21, width: 21, boxShadow:0 }

class Toggle extends Component {
  render() {
    let classNames = styles.toggle

    if(this.props.multiLine){
      classNames = classNames + ' ' + styles.isMultiLine
    }

    if(this.props.align === 'left'){
      classNames = classNames + ' ' + styles.isLeft
    }
    return (
      <div className={classNames}>
        <ToggleButton  
          colors={{
            activeThumb: {
              base: '#FFFFFF',
            },
            inactiveThumb: {
              base: '#FFFFFF',
            },
            active: {
              base: '#60C325',
              hover: '#71bf42',
            },
            inactive: {
              base: '#D8D8D8',
              hover: '#cacaca',
            }
          }}
          trackStyle={trStyle}
          thumbStyle={thStyle}
          inactiveLabel=""
          activeLabel=""
          thumbAnimateRange={[3, 25]}
          value={this.props.value}
          onToggle={(value) => this.props.changed(!value, this.props.identifier)}
        />
      </div>
    )
  }
}

export default Toggle



// WEBPACK FOOTER //
// ./src/components/atoms/Toggle/index.js